import { DateTime, Duration } from 'luxon';
import store from '@/store';

function formatToSeconds(time, formatter) {
	if (time === null || time === undefined) {
		return 0;
	}
	if (time.indexOf(':') !== -1) {
		const splitTime = time.split(':');
		if (splitTime.length === 2) {
			if (splitTime[1].length !== 2) {
				return 0;
			}
			const hours = splitTime[0].length < 2 ? '0' + splitTime[0] : splitTime[0];
			const minutes = splitTime[1];
			return Math.round(formatter(hours, minutes));
		}
	}
	return 0;
}

const filter = {
	formatDate: (value) => {
		if (value) {
			if (value instanceof DateTime) {
				return value.toFormat(store.state.profile?.locale?.dateFormat);
			}

			return DateTime.fromISO(String(value)).toFormat(store.state.profile.locale.dateFormat);
		}
	},

	formatSecondsTime: function (seconds) {
		if (seconds === undefined || seconds === null) {
			// Not defined
			return undefined;
		}
		if (isNaN(seconds)) {
			// No number
			return undefined;
		}
		return DateTime.fromSeconds(seconds).toFormat(store.state.profile.locale.dateFormat);
	},

	formatSecondsDuration: function (seconds) {
		if (seconds === null || seconds === undefined || seconds === '') {
			// Not defined
			return undefined;
		}
		const duration = Duration.fromObject({ seconds: seconds });
		if (!duration.isValid) {
			// Invalid
			return undefined;
		}
		if (seconds < 0) {
			const time = duration.negate().toFormat('hh:mm');
			return time === '00:00' ? time : `-${time}`;
		}
		return duration.toFormat('hh:mm');
	},

	formatSecondsDurationWithSeconds: function (seconds) {
		if (seconds === undefined || seconds === null) {
			// not defined
			return undefined;
		}
		if (isNaN(seconds)) {
			// No number
			return undefined;
		}
		return Duration.fromObject({ seconds: seconds }).toFormat('hh:mm:ss');
	},

	formatTime: function (value) {
		if (value) {
			return DateTime.fromISO(String(value)).toFormat(store.state.profile.locale.timeFormat);
		}
	},

	formatDateTime: function (value) {
		if (value) {
			if (value instanceof DateTime) {
				return value.toFormat(store.state.profile?.locale?.dateTimeFormat);
			}

			return DateTime.fromISO(String(value)).toFormat(store.state.profile.locale.dateTimeFormat);
		}
	},

	decimal2: function (value) {
		if (value === undefined || value === null) {
			// not defined
			return null;
		}
		if (isNaN(value)) {
			// No number
			return null;
		}
		return Math.round(value * 100) / 100;
	},

	decimal: function (value) {
		if (value === undefined || value === null) {
			// not defined
			return null;
		}
		if (isNaN(value)) {
			// No number
			return null;
		}
		return Math.round(value);
	},

	limitLength: function (text, length) {
		if (text) {
			const content = JSON.stringify(text);
			return content.length > length ? content.slice(0, length) + '…' : content;
		}
	},

	formatTimeToSeconds: function (time) {
		return formatToSeconds(time, (hours, minutes) => Duration.fromISOTime(hours + ':' + minutes).toMillis() / 1000);
	},

	formatDurationToSeconds: function (time) {
		return formatToSeconds(time, (hours, minutes) => hours * 3600 + minutes * 60);
	},
};

export default filter;
